<template>
  <div class="devicesLang app-container">
    <div class="global-header-wrap">
      <h3>设备语言标签管理</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="devicesLang-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
          <div class="devicesLang-header-right">
            <button
              class="global-button-style"
              @click="
                (title = '新增标签'), $store.commit('windowHandle', 'addPopup')
              "
            >
              新增语言标签
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <addTagPopup
        v-if="addPopup"
        :title="title"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="addEvn"
      />
    </transition>
    <el-dialog
      title="标签详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="tagItem">
        <div class="devicesLang-dialog-item">
          <p>标签名称</p>
          <p>{{ tagItem.name }}</p>
        </div>
        <div class="devicesLang-dialog-item">
          <p>设备语言</p>
          <p>{{ tagItem.langs.join("\\") }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import addTagPopup from "../components/addTagPopup";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    addTagPopup,
    appTable,
    pagination
  },
  computed: {
    ...mapGetters(["addPopup"]),
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: this.$t("org.tagName"),
          placeholder: this.$t("placeholder.tagName")
        },
        {
          prop: "langs",
          label: "设备语言(多种语言用\\隔开)",
          placeholder: "请输入设备语言"
        }
      ];
      return ruleProps;
    },
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ]
        // langs: [
        //   { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        // ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("org.tagName")
        },
        {
          prop: "updatedAt",
          label: "创建时间"
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          btn: [
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      ruleForm: {
        name: "",
        langs: ""
      },
      params: {
        limit: 20,
        page: 1
      },
      tableData: [],
      total: 0,
      title: "",
      tagItem: null,
      centerDialogVisible: false
    };
  },
  methods: {
    getList() {
      this.$http.getLangGroups(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    del(data) {
      this.$http.delLangGroups(data.row._id).then(res => {
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        this.tableData.splice(data.$index, 1);
      });
    },

    toDetails(data) {
      this.tagItem = data.row;
      this.centerDialogVisible = true;
    },

    edit(data) {
      this.tagItem = data.row;
      this.ruleForm.name = data.row.name;
      this.ruleForm.langs = data.row.langs.join("\\");
      this.title = "编辑标签";
      this.$store.commit("windowHandle", "addPopup");
    },

    addEvn(data) {
      data.langs = data.langs.split("\\");
      if (this.title === "新增标签") {
        this.$http.createLangGroups(data).then(res => {
          this.elMsg(this.$t("alertMsg.addSuccess"), "success");
          this.getList();
        });
      } else {
        this.$http.updateLangGroups(this.tagItem._id, data).then(res => {
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
          this.getList();
        });
      }
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val;
      } else {
        delete this.params.name;
      }
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.devicesLang {
  .devicesLang-btn {
    text-align: right;
    padding: 10px;
  }
  .devicesLang-pagination {
    padding: 10px;
    text-align: right;
  }
  .devicesLang-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
}
</style>
